module.exports = __webpack_public_path__ + "img/1.685243fa.svg";